import { render, staticRenderFns } from "./pickPackShipStep1.vue?vue&type=template&id=e71c0042"
import script from "./pickPackShipStep1.vue?vue&type=script&lang=js"
export * from "./pickPackShipStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports